import { ICollectionResponse } from "../../models/ICollectionResponse";
import { IStorefrontBundleDetail, IStorefrontBundleView, IStorefrontCategoryView, IStorefrontProductView } from "../../models/StorefrontProducts";
import api from "../Api";

const storefrontProductEndpoints = api.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getStorefrontCategories: build.query<ICollectionResponse<IStorefrontCategoryView>, { subUrl: string }>({
            query: (arg) => `storefront/storefronts/${arg.subUrl}/categories`
        }),
        getStorefrontFeaturedProducts: build.query<ICollectionResponse<IStorefrontProductView>, { id: string, maxEntries?: number }>({
            query: (arg) => ({
                url: `storefront/storefronts/${arg.id}/sections/featured`,
                params: {
                    maxEntries: arg.maxEntries
                }
            })
        }),
        getStorefrontBundles: build.query<ICollectionResponse<IStorefrontBundleView>, { id: string, maxEntries?: number }>({
            query: (arg) => ({
                url: `storefront/storefronts/${arg.id}/sections/bundles`,
                params: {
                    maxEntries: arg.maxEntries
                }
            })
        }),
        getStorefrontCategorySectionPreview: build.query<ICollectionResponse<IStorefrontProductView>, { id: string, segments?: string[], categories?: string[], manufacturers?: string[], subCategories?: string[], tags?: string[], maxEntries?: number }>({
            query: (arg) => ({
                url: `storefront/storefronts/${arg.id}/sections/categories`,
                params: {
                    segments: arg.segments,
                    categories: arg.categories,
                    manufacturers: arg.manufacturers,
                    subCategories: arg.subCategories,
                    tags: arg.tags,
                    maxEntries: arg.maxEntries
                }
            })
        }),
        getStorefrontSectionProducts: build.query<ICollectionResponse<IStorefrontProductView>, { storefrontId: string, sectionId: string}>({
            query: (arg) => ({
                url: `storefront/storefronts/${arg.storefrontId}/sections/${arg.sectionId}/products`
            })
        }),
        getStorefrontSavedSearchProducts: build.query<ICollectionResponse<IStorefrontProductView>, { id: string }>({
            query: (arg) => ({
                url: `storefront/storefronts/${arg.id}/sections/savedSearches`
            })
        }),
        getStorefrontProductDetail: build.query<IStorefrontProductView, { storefrontId: string, productId: string }>({
            query: (arg) => `storefront/storefronts/${arg.storefrontId}/products/${arg.productId}`
        }),
        getStorefrontBundleDetail: build.query<IStorefrontBundleDetail, { storefrontId: string, bundleId: string }>({
            query: (arg) => `storefront/storefronts/${arg.storefrontId}/bundles/${arg.bundleId}`
        }),
    })
});

export const {
    useGetStorefrontCategoriesQuery,
    useGetStorefrontFeaturedProductsQuery,
    useGetStorefrontBundlesQuery,
    useGetStorefrontCategorySectionPreviewQuery,
    useGetStorefrontSectionProductsQuery,
    useGetStorefrontSavedSearchProductsQuery,
    useGetStorefrontProductDetailQuery,
    useLazyGetStorefrontProductDetailQuery,
    useGetStorefrontBundleDetailQuery,
} = storefrontProductEndpoints;